document.addEventListener('DOMContentLoaded', function () {
  initReveal();
  initAntesDespues();
  initGaleriaProducto();
  initSelectorVariantes();
  initHeroCarousel();
});

/* Animación de entrada al hacer scroll */
function initReveal() {
  var elementos = document.querySelectorAll('.mt-reveal');
  if (!elementos.length) return;

  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
    elementos.forEach(function (el) { el.classList.add('mt-visible'); });
    return;
  }

  var observer = new IntersectionObserver(
    function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('mt-visible');
          observer.unobserve(entry.target);
        }
      });
    },
    { threshold: 0, rootMargin: '0px 0px 600px 0px' }
  );

  elementos.forEach(function (el) { observer.observe(el); });
}

/* Toggle "antes / después" */
function initAntesDespues() {
  var switches = document.querySelectorAll('.mt-ad-switch');
  switches.forEach(function (sw) {
    var botones = sw.querySelectorAll('button');
    var wrap = sw.closest('.mt-ad-wrap') || document;
    var paneles = wrap.querySelectorAll('.mt-ad-panel');

    botones.forEach(function (btn) {
      btn.addEventListener('click', function () {
        var estado = btn.getAttribute('data-estado');
        sw.setAttribute('data-estado', estado);
        botones.forEach(function (b) { b.classList.toggle('mt-activo', b === btn); });
        paneles.forEach(function (p) {
          p.classList.toggle('mt-activo', p.getAttribute('data-tipo') === estado);
        });
      });
    });
  });
}

/* Galería de producto: imagen principal + miniaturas */
function initGaleriaProducto() {
  var galerias = document.querySelectorAll('[data-mt-galeria]');
  galerias.forEach(function (galeria) {
    var principal = galeria.querySelector('[data-mt-gal-principal]');
    var minis = galeria.querySelectorAll('[data-mt-gal-mini]');
    if (!principal || !minis.length) return;

    minis.forEach(function (mini) {
      mini.addEventListener('click', function () {
        var src = mini.getAttribute('data-full');
        if (!src) return;
        principal.src = src;
        minis.forEach(function (m) { m.classList.remove('mt-activo'); });
        mini.classList.add('mt-activo');
      });
    });
  });
}

/* Carrusel del hero: rota las fotos de producto con crossfade + zoom lento,
   pausa al pasar el ratón/tocar, y sincroniza la insignia de precio flotante. */
function initHeroCarousel() {
  var carrusel = document.querySelector('[data-mt-hero-carousel]');
  if (!carrusel) return;

  var slides = Array.prototype.slice.call(carrusel.querySelectorAll('[data-mt-hero-slide]'));
  if (slides.length < 2) return;

  var dots = Array.prototype.slice.call(carrusel.querySelectorAll('[data-mt-hero-dots] .mt-hero-dot'));
  var tira = Array.prototype.slice.call(document.querySelectorAll('[data-mt-hero-strip] .mt-hero-strip-item'));
  var badge = document.querySelector('[data-mt-hero-badge]');
  var precioEl = badge && badge.querySelector('[data-mt-badge-precio]');
  var etiquetaEl = badge && badge.querySelector('[data-mt-badge-etiqueta]');
  var reducirMovimiento = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var actual = 0;
  var temporizador = null;
  var badgeTimeoutId = null;
  var INTERVALO = 5500;

  function sincronizarPaneles(indice) {
    document.body.setAttribute('data-mt-panel-activo', String(indice));
    document.querySelectorAll('[data-mt-panel]').forEach(function (el) {
      el.setAttribute('aria-hidden', el.getAttribute('data-mt-panel') === String(indice) ? 'false' : 'true');
    });

    /* La sección de reseñas es una sola para los 5 productos (para no gastar
       más de una sección del límite de Shopify); si el producto activo
       todavía no tiene ninguna reseña real cargada, se oculta la sección
       entera en vez de enseñar una cuadrícula vacía. */
    var resenasGrid = document.querySelector('[data-mt-resenas]');
    if (resenasGrid) {
      var hayResenas = resenasGrid.querySelector('[data-mt-review-index="' + indice + '"]') !== null;
      var seccionResenas = resenasGrid.closest('.mt-res-wrap');
      if (seccionResenas) seccionResenas.style.display = hayResenas ? '' : 'none';
    }
  }

  /* Producto aleatorio al cargar: cada visita empieza en un producto distinto
     del catálogo (el HTML siempre marca el slide 0 como activo por defecto;
     aquí, antes de pintar nada, movemos ese estado inicial a un índice al
     azar). La navegación manual con los puntos sigue disponible siempre. */
  var indiceInicial = Math.floor(Math.random() * slides.length);
  if (indiceInicial !== 0) {
    slides[0].classList.remove('mt-activo');
    dots[0] && dots[0].classList.remove('mt-activo');
    tira[0] && tira[0].classList.remove('mt-activo');
    slides[indiceInicial].classList.add('mt-activo');
    dots[indiceInicial] && dots[indiceInicial].classList.add('mt-activo');
    tira[indiceInicial] && tira[indiceInicial].classList.add('mt-activo');
    actual = indiceInicial;
    if (badge) {
      var activoInicial = slides[indiceInicial];
      if (precioEl) precioEl.textContent = activoInicial.getAttribute('data-precio') || '';
      if (etiquetaEl) etiquetaEl.textContent = activoInicial.getAttribute('data-etiqueta') || '';
      badge.setAttribute('href', activoInicial.getAttribute('data-producto-url') || '#');
    }
  }
  sincronizarPaneles(actual);

  function irA(indice) {
    var destino = (indice + slides.length) % slides.length;
    if (destino === actual) return;

    slides[actual].classList.remove('mt-activo');
    dots[actual] && dots[actual].classList.remove('mt-activo');
    tira[actual] && tira[actual].classList.remove('mt-activo');

    actual = destino;

    slides[actual].classList.add('mt-activo');
    dots[actual] && dots[actual].classList.add('mt-activo');
    tira[actual] && tira[actual].classList.add('mt-activo');
    sincronizarPaneles(actual);

    if (badge) {
      /* El texto se actualiza al instante (nunca queda desincronizado de la
         imagen, aunque el usuario cambie de slide varias veces seguidas muy
         rápido); solo el brillo de opacidad es el que da la sensación de
         cambio suave, vía CSS. */
      var activo = slides[destino];
      if (precioEl) precioEl.textContent = activo.getAttribute('data-precio') || '';
      if (etiquetaEl) etiquetaEl.textContent = activo.getAttribute('data-etiqueta') || '';
      badge.setAttribute('href', activo.getAttribute('data-producto-url') || '#');

      badge.classList.remove('mt-badge-cambiando');
      void badge.offsetWidth;
      badge.classList.add('mt-badge-cambiando');
      if (badgeTimeoutId) window.clearTimeout(badgeTimeoutId);
      badgeTimeoutId = window.setTimeout(function () {
        badge.classList.remove('mt-badge-cambiando');
        badgeTimeoutId = null;
      }, 180);
    }
  }

  function siguiente() { irA(actual + 1); }

  function iniciarAutoplay() {
    if (reducirMovimiento) return;
    detenerAutoplay();
    temporizador = window.setInterval(siguiente, INTERVALO);
  }
  function detenerAutoplay() {
    if (temporizador) window.clearInterval(temporizador);
    temporizador = null;
  }

  dots.forEach(function (dot) {
    dot.addEventListener('click', function () {
      irA(parseInt(dot.getAttribute('data-index'), 10));
      iniciarAutoplay();
    });
  });

  tira.forEach(function (item) {
    item.addEventListener('click', function () {
      irA(parseInt(item.getAttribute('data-index'), 10));
      iniciarAutoplay();
    });
  });

  carrusel.addEventListener('mouseenter', detenerAutoplay);
  carrusel.addEventListener('mouseleave', iniciarAutoplay);
  carrusel.addEventListener('focusin', detenerAutoplay);
  carrusel.addEventListener('focusout', iniciarAutoplay);

  /* Deslizar con el dedo en móvil */
  var xInicio = null;
  carrusel.addEventListener('touchstart', function (e) {
    xInicio = e.touches[0].clientX;
    detenerAutoplay();
  }, { passive: true });
  carrusel.addEventListener('touchend', function (e) {
    if (xInicio === null) return;
    var diferencia = e.changedTouches[0].clientX - xInicio;
    if (Math.abs(diferencia) > 40) {
      diferencia < 0 ? irA(actual + 1) : irA(actual - 1);
    }
    xInicio = null;
    iniciarAutoplay();
  });

  /* Solo gira mientras el hero está visible: si el usuario ya bajó a leer
     las secciones de abajo, no le cambiamos el contenido bajo los pies. */
  if ('IntersectionObserver' in window) {
    var heroObserver = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        entry.isIntersecting ? iniciarAutoplay() : detenerAutoplay();
      });
    }, { threshold: 0.3 });
    heroObserver.observe(carrusel.closest('.mt-hero-wrap') || carrusel);
  } else {
    iniciarAutoplay();
  }
}

/* Selector de variantes: actualiza precio, id de variante y estado de stock */
function initSelectorVariantes() {
  var forms = document.querySelectorAll('[data-mt-producto]');
  forms.forEach(function (contenedor) {
    var dataEl = contenedor.querySelector('[data-mt-variantes]');
    if (!dataEl) return;

    var variantes;
    try {
      variantes = JSON.parse(dataEl.textContent);
    } catch (e) {
      return;
    }

    var botonesGrupo = contenedor.querySelectorAll('[data-mt-opcion]');
    var inputId = contenedor.querySelector('[data-mt-input-id]');
    var precioEl = contenedor.querySelector('[data-mt-precio]');
    var precioAntesEl = contenedor.querySelector('[data-mt-precio-antes]');
    var btnComprar = contenedor.querySelector('[data-mt-btn-comprar]');
    var seleccion = {};

    contenedor.querySelectorAll('[data-mt-opcion-btn]').forEach(function (btn) {
      if (btn.classList.contains('mt-activo')) {
        seleccion[btn.getAttribute('data-mt-opcion')] = btn.getAttribute('data-mt-valor');
      }
    });

    function formatoNumero(valor, decimales, separadorDecimal, separadorMiles) {
      var fijo = valor.toFixed(decimales);
      var partes = fijo.split('.');
      var entero = partes[0].replace(/\B(?=(\d{3})+(?!\d))/g, separadorMiles);
      return decimales > 0 ? entero + separadorDecimal + partes[1] : entero;
    }

    function formatoDinero(centavos) {
      var valor = centavos / 100;
      var formato = window.mtMoneyFormat || '€{{amount}}';
      var reemplazos = {
        amount: formatoNumero(valor, 2, '.', ','),
        amount_no_decimals: formatoNumero(valor, 0, '', ','),
        amount_with_comma_separator: formatoNumero(valor, 2, ',', '.'),
        amount_no_decimals_with_comma_separator: formatoNumero(valor, 0, '', '.'),
        amount_with_space_separator: formatoNumero(valor, 2, ',', ' '),
        amount_no_decimals_with_space_separator: formatoNumero(valor, 0, '', ' ')
      };
      return formato.replace(/\{\{\s*(\w+)\s*\}\}/g, function (_, clave) {
        return clave in reemplazos ? reemplazos[clave] : '';
      });
    }

    function encontrarVariante() {
      return variantes.find(function (v) {
        return Object.keys(seleccion).every(function (k) {
          return v.options[k] === seleccion[k];
        });
      });
    }

    function actualizar() {
      var variante = encontrarVariante();
      if (!variante) return;

      if (inputId) inputId.value = variante.id;
      if (precioEl) precioEl.textContent = formatoDinero(variante.price);
      if (precioAntesEl) {
        if (variante.compare_at_price && variante.compare_at_price > variante.price) {
          precioAntesEl.textContent = formatoDinero(variante.compare_at_price);
          precioAntesEl.style.display = '';
        } else {
          precioAntesEl.style.display = 'none';
        }
      }
      if (btnComprar) {
        btnComprar.disabled = !variante.available;
        btnComprar.querySelector('[data-mt-btn-texto]').textContent = variante.available
          ? btnComprar.getAttribute('data-texto-disponible')
          : btnComprar.getAttribute('data-texto-agotado');
      }

      botonesGrupo.forEach(function (grupo) {
        var nombreOpcion = grupo.getAttribute('data-mt-opcion');
        grupo.querySelectorAll('[data-mt-opcion-btn]').forEach(function (btn) {
          var valor = btn.getAttribute('data-mt-valor');
          var pruebaSeleccion = Object.assign({}, seleccion, {});
          pruebaSeleccion[nombreOpcion] = valor;
          var existe = variantes.some(function (v) {
            return Object.keys(pruebaSeleccion).every(function (k) {
              return v.options[k] === pruebaSeleccion[k];
            });
          });
          btn.disabled = !existe;
        });
      });
    }

    contenedor.querySelectorAll('[data-mt-opcion-btn]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        if (btn.disabled) return;
        var opcion = btn.getAttribute('data-mt-opcion');
        var valor = btn.getAttribute('data-mt-valor');
        seleccion[opcion] = valor;

        contenedor.querySelectorAll('[data-mt-opcion="' + opcion + '"] [data-mt-opcion-btn]').forEach(function (b) {
          b.classList.toggle('mt-activo', b === btn);
        });
        actualizar();
      });
    });

    actualizar();
  });
}
